import { httpClient } from 'app/api/http/http-client';
import { useMutation, useQuery } from 'react-query';
import { HomePageResponseType } from 'app/utils/services/types/homePage.type';
import logger from 'app/utils/logger';
import { useGetDataTransfer } from 'app/utils/services/transferService';
// import { useRefreshTokenService } from './refreshTokenService';

const refreshToken = localStorage.getItem('refreshToken');

const homePageService = {
  getHomePage: async () => {
    try {
      const result = await httpClient.post<HomePageResponseType>('/api-web/v1/main/home-page', null);

      // logger.log(result);

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'home-page';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },

  changeLangHomePage: async (data: any) => {
    try {
      const result = await httpClient.post<any>(`/api-web/v1/main/get_header_menu`, null);

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }
    }
  },

  getHeaderAndMenu: async (lang: any, path: any) => {
    try {
      const result = await httpClient.post<any>('/api-web/v1/main/get_header_menu', null, {
        headers: { Language: lang },
      });

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          if (path === 'accounts_card?type=accounts' || path === 'accounts_card?type=cards') {
            window.location.href = path;
          } else {
            window.location.href = path.slice(1);
          }
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },
};

export const useGetHomePageService = () => {
  const {
    isLoading: isLoadingGetHomePage,
    data: dataGetHomePage,
    refetch: refetchGetHomePage,
  } = useQuery(['getHomePage'], homePageService.getHomePage, { cacheTime: 0 });

  return { isLoadingGetHomePage, dataGetHomePage, refetchGetHomePage };
};

export const useChangeLangHomePageService = (path: string) => {
  const {
    isLoading: isLoadingChangeLangHomePage,
    isSuccess,
    data: dataChangeLangHomePage,
    mutate: homeChangeLangPageMutation,
  } = useMutation(['homePageLang'], (data: any) => homePageService.changeLangHomePage(data), {
    onSuccess: async () => {
      try {
        const result = await httpClient.post<HomePageResponseType>(`/api-web/v1/main/${path}`, null);

        return result;
      } catch (err: any) {
        if (err?.response.status === 400) {
          return err?.response.data;
        }
      }
    },
  });

  return { isLoadingChangeLangHomePage, isSuccess, dataChangeLangHomePage, homeChangeLangPageMutation };
};

export const useGetHeaderAndMenu = (lang: any, path: any) => {
  const {
    isLoading: isLoadingHeaderAndMenu,
    data: dataHeaderAndMenu,
    refetch: refetchGetHeaderAndMenu,
  } = useQuery(['getHeaderAndMenu', lang], () => homePageService.getHeaderAndMenu(lang, path));

  return { isLoadingHeaderAndMenu, dataHeaderAndMenu, refetchGetHeaderAndMenu };
};
